import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { TipoEsecuzione } from "../../../../common/models/tipologiche/tipo-esecuzione";

export class FascicoloEsecuzione extends FascicoloFull {
  tipoEsecuzione: TipoEsecuzione;
  sezione: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
